/*
 * Sonner Toaster — wrapper shadcn (Lot 5bis, 2026-04-30) qui remplace
 * `<ToastContainer>` de `react-toastify`. Configuré pour matcher l'ancien
 * `autoClose={2000}` (devient `duration={2000}` en prop par défaut côté
 * `toast.success/error`).
 *
 * Différences avec le template shadcn original :
 *   - Pas de `next-themes` : l'app n'a pas de dark mode actif (les
 *     variables `.dark` du CSS sont définies mais aucun toggle ne les
 *     applique). Theme codé en dur "light" — quand un toggle dark sera
 *     ajouté, on plombera ici.
 *   - `richColors` activé pour différencier visuellement success/error
 *     (le défaut Sonner est monochrome). Cohérent avec ce que faisait
 *     react-toastify (icônes colorées).
 */
import {
  CircleCheck,
  Info,
  LoaderCircle,
  OctagonX,
  TriangleAlert,
} from "lucide-react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      richColors
      // 2s par défaut — match l'ancien `<ToastContainer autoClose={2000} />`.
      // Override possible callsite par callsite via `toast(msg, { duration })`.
      duration={2000}
      icons={{
        success: <CircleCheck className="h-4 w-4" />,
        info: <Info className="h-4 w-4" />,
        warning: <TriangleAlert className="h-4 w-4" />,
        error: <OctagonX className="h-4 w-4" />,
        loading: <LoaderCircle className="h-4 w-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
